<template>
    <div>
        <modal class="member-list" :display="modalStatus.bizMemberList" @modalStatus="closeModal" >
            <h1>{{title}}</h1>
            <div class="member-list-wrap">
                <div class="content">
                    <div class="table-title">
                        <div class="name">姓名</div>
                        <div class="phone">手機號碼</div>
                        <div class="created">建立時間</div>
                    </div>
                    <div class="table-body" >
                        <ul :key="'height'+componentKey" v-bind:style="{'height': modalHeight}">
                            <li v-for="(item, index) in list" :key="index">
                                <div class="name">{{item.name}}</div>
                                <div class="phone">{{item.phoneNumber}}</div>
                                <div class="created">{{getFormatDateTime(item.createdDate)}}</div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            // list: [],
            modalHeight: (window.innerHeight-300) + 'px',
            componentKey: 0,
        }
    },
    mounted (){
        window.addEventListener('resize', this.resizeModal)
    },
    destroyed() {
        window.removeEventListener('resize', this.resizeModal)
    },
    props: {
        obj: null
    },
    watch: {
        modalStatus: {
            handler: function (val) {
               
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        resizeModal: function (){
            let _self = this
            if( window.innerHeight > 610){
                _self.modalHeight = (window.innerHeight-400) + 'px'
                _self.componentKey += 1
            }
        },
        closeModal: function () {
            this.$store.dispatch('setModalStatus', {state: false, type: 'bizMemberList'})
        },
    },
    computed: {
        list: function () {
            return this.obj.memberList
        },
        title: function () {
            if(!this.obj) return
            let name = this.obj.groupName?this.obj.groupName:this.obj.roleName
            let total = this.obj.memberList.length
            return name+'的 '+total+' 位成員'
        },
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
    }
}
</script>
<style lang="scss"  >
    #modal.member-list{
        .error{
            right: 0px;
            top: 7px;
        }
        .modal-content{
            width: 448px;
            padding: 0 !important;
            .detail{
                >h1{
                    margin-top: 32px;
                    margin-bottom: 24px;
                    padding: 0 45px;
                }
                .member-list-wrap{
                    padding: 0 32px 0 32px;
                    .content{
                        .table-title{
                            padding: 20px 20px;
                            border-top: 1px solid #F1F5F4;
                            border-bottom: 1px solid #F1F5F4;
                            display: flex;
                            align-items: center;
                            color: #a8a5a4;
                        }
                        .table-body{
                            ul{
                                &::-webkit-scrollbar {
                                    display: none;
                                }
                                height: 392px;
                                overflow-x: hidden;
                                li{
                                    display: flex;
                                    align-items: center;
                                    padding: 16px 20px;
                                    border-bottom: 1px solid #F1F5F4;
                                }
                            }
                        }
                        .table-title .name,
                        .table-body ul li .name{
                            width: 50px;
                            margin-right: 60px;
                        }
                        .table-title .phone,
                        .table-body ul li .phone{
                            width: 88px;
                            margin-right: 58px;
                        }
                        
                        .table-title .created,
                        .table-body ul li .created{
                            width: 80px;
                        }
                    }
                }
            }
        }
    }
    // @media screen and (max-width: 1280px) {
    //     #modal.member-list{
    //         .modal-content{
    //             width: 1194px;
    //             .detail{
    //                 .member-list-wrap{
    //                     .content{
    //                         .table-title .name,
    //                         .table-body ul li .name{
    //                             width: 160px;
    //                             margin-right: 40px;
    //                         }
    //                     }
    //                 }
    //             }
    //         }
    //     }
    // }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/modals/memberList.vue